import { CTABannerRefProjection } from '../references/CTABannerRef.query';
import { testimonialRefProjection } from '../references/testimonialRef.query';

export const queryCaseStudy = groq`
  *[_type == "caseStudy" && currentPathname == $currentPathname][0]{
  ...,
    CTABanner {
      reference-> ${CTABannerRefProjection}
    },
  "caseStudyContent": {
    theChallenge,
    results,
    pdf,
    _rev,
    content,
     testimonial {
      reference-> ${testimonialRefProjection}
    },
  },
    "caseStudyHero": {
    pageType,
    title,
    subtitle,
    heroImage,
    wistiaVideoMetadata,
    video
  },
  }
`;
